import {Text, TouchableOpacity, View} from 'react-native';
import React, {useState} from 'react';
import {useTheme} from 'contexts/ThemeContext';
import DropDownListForWeb from '../dropDownListForWeb';
import styleSheet from './styles';

export interface DropDownPickerProps {
  data: string[];
  onValueChange(value: string): void;
  label: string;
  pickerContainerStyle?: object;
  zIndex?: object;
}

const DropDownPicker = (props: DropDownPickerProps) => {
  const styles = styleSheet(useTheme());
  const theme = useTheme();

  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const onHandle = (title: string) => {
    props.onValueChange(title);

    setIsOpen(!isOpen);
  };

  const button = (
    <TouchableOpacity
      onPress={toggle}
      activeOpacity={0.8}
      style={[
        styles.defaultPickerContainerStyle(isOpen),
        props.pickerContainerStyle,
      ]}>
      <Text style={styles.pickerLabelStyle}>{props.label}</Text>
    </TouchableOpacity>
  );

  return (
    <View style={[styles.containerStyle, props.zIndex]}>
      {button}

      <DropDownListForWeb
        isOpen={isOpen}
        data={props.data}
        onPress={value => onHandle(value)}
        label={props.label}
        pickerContainerStyle={[
          styles.flatListStyle,
          props.pickerContainerStyle,
        ]}
      />
    </View>
  );
};

export default DropDownPicker;
